/* src/app/shared/components/multi-charts/multi-charts.component.scss */
.chart-container {
  position: relative;
}
.chart-container h5 {
  position: absolute;
  top: 50%;
  left: 33%;
}
::ng-deep .tick text {
  font-size: 0.875rem;
  line-height: 1.25rem;
  fill: #635f5d;
}
::ng-deep .xAxis .tick {
  width: 1rem;
}
::ng-deep .xAxis .tick text {
  word-wrap: break-word;
}
::ng-deep .axis-label {
  font-size: 1rem !important;
  fill: #8e8883;
}
::ng-deep .title {
  font-size: 1rem !important;
  fill: #635f5d;
}
::ng-deep .tick line {
  stroke: "#eee";
  opacity: 0.1;
}
::ng-deep .chart-tooltip {
  position: absolute;
  box-sizing: border-box;
  width: 248px;
  border: 1px solid #5c5c5c;
  border-radius: 0.5rem;
  background-color: #333;
  padding: 12px;
  box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.1);
  margin-top: -30px;
  font-size: 1rem;
  letter-spacing: 0.5px;
  line-height: 22px;
  z-index: 9999;
  color: #fff;
  pointer-events: none;
  text-transform: capitalize;
}
::ng-deep .no-data {
  font-size: 24px !important;
  overflow: hidden !important;
}
::ng-deep .data-container {
  overflow: hidden !important;
}
/*# sourceMappingURL=multi-charts.component.css.map */
